import styles from './SellPage.module.css';

export const SellPage: React.FC = ({ children }) => {
	return <div className={styles.page}>{children}</div>;
};
